import React from 'react';
import styled from '@emotion/styled';
import YearIcon from 'assets/svg/building-icons/year.svg';
import { Text } from 'ds/components/typography';
import { ShowAt } from 'consts/breakpoints';
import { INewDevelopmentJob } from 'store/state/selectors/insights/summaryTypes';
import { useLocale } from 'locale';
import { ConstructionStoriesAndUnits } from './ConstructionStoriesAndUnits';
import {
  ConstructionDescription,
  ConstructionItemWrapper,
  EstablishmentEndWrapper,
  LocationTextWrapper,
} from './styled';


const AddressWrapper = styled(Text)`
  text-transform: capitalize;
`;

export const ConstructionItem: React.FunctionComponent<INewDevelopmentJob> = (props) => {
  const {
    jobLocation : { houseNumber, street, jobAddress },
    smartSentence: { jobDescription, stories, units, estEnd },
    timeLine,
  } = props;
  const { t } = useLocale();
  const resultJobAddress = street ? t('newConstruction.address', { houseNumber, street }) : jobAddress;

  return (
    <ConstructionItemWrapper>
      <ShowAt to={2}>
        <LocationTextWrapper>
          <AddressWrapper weight="bold">
            {resultJobAddress}
          </AddressWrapper>
        </LocationTextWrapper>
        <EstablishmentEndWrapper>
          <YearIcon/>
          <Text>
            {t('newConstructionEstablishmentEnd', { date: estEnd || (timeLine && timeLine.end) })}
          </Text>
        </EstablishmentEndWrapper>
      </ShowAt>
      <ShowAt from={3}>
        <LocationTextWrapper>
          <AddressWrapper weight="bold">
            {resultJobAddress}
          </AddressWrapper>
        </LocationTextWrapper>
        <ConstructionDescription>
          <Text>
            {jobDescription}
          </Text>
          <ConstructionStoriesAndUnits
            units={units}
            stories={stories}
          />
          <EstablishmentEndWrapper>
            <YearIcon/>
            <Text>
              {t('newConstructionEstablishmentEnd', { date: estEnd || (timeLine && timeLine.end) })}
            </Text>
          </EstablishmentEndWrapper>
        </ConstructionDescription>
      </ShowAt>
    </ConstructionItemWrapper>
  );
};
